const HistoryRecords = {
  list: [],
  register: (key, callback) => {
    HistoryRecords.list.push({
      key,
      callback
    });
  },
  push: (key, callback) => {
    HistoryRecords.register(key, callback);
    window.history.pushState(key, null, `#${key}`);
  },
  pop: () => {
    window.history.back();
  },
  init: () => {
    window.addEventListener('popstate', (e) => {
      if (e) {
        console.log(`in pop`, e.state);
        const { state } = e;
        let record = HistoryRecords.list.pop();
        // console.log(`history pop`, record);
        if (record && record.callback) {
          record.callback();
        }
      }
    });
  }
};

HistoryRecords.init();

export const pushHistory = HistoryRecords.push;
export const popHistory = HistoryRecords.pop;
// 页面整页跳转后回到已有 hash 时，重新关联该 history entry 的关闭回调。
export const registerHistory = HistoryRecords.register;

export default HistoryRecords;
